import localforage from 'localforage';

const backgroundGpsStore = localforage.createInstance({
  name: 'backgroundGPS',
  storeName: 'coords',
});

const BACKGROUND_GPS_MAX_AGE = 15 * 60 * 1000;
const FRESH_GPS_MAX_AGE = 3 * 60 * 1000;

export const getBackgroundCoords = async (maxAge = BACKGROUND_GPS_MAX_AGE) => {
  try {
    const stored = await backgroundGpsStore.getItem('lastCoords');
    if (stored && Date.now() - stored.timestamp < maxAge) {
      return stored.coords;
    }
  } catch {}
  return null;
};

const getCoords = async (highAccuracy = true) => {
  const fresh = await getBackgroundCoords(FRESH_GPS_MAX_AGE);
  if (fresh) return fresh;

  if (!navigator.geolocation) return getBackgroundCoords();

  if (navigator.permissions) {
    try {
      const permission = await navigator.permissions.query({ name: 'geolocation' });
      if (permission.state === 'denied') return getBackgroundCoords();
    } catch {}
  }

  return new Promise((resolve) => {
    navigator.geolocation.getCurrentPosition(
      (position) => resolve(position.coords),
      async (error) => {
        if (highAccuracy && (error.code === error.TIMEOUT || error.code === error.POSITION_UNAVAILABLE)) {
          resolve(getCoords(false));
        } else {
          resolve(await getBackgroundCoords());
        }
      },
      {
        enableHighAccuracy: highAccuracy,
        timeout: highAccuracy ? 15000 : 10000,
        maximumAge: 30000,
      },
    );
  });
};

export default getCoords;
